/**
 * Main State View.
 * Responsible for rendering the bulk tanks and all events.
 */

var VRC = VRC || {};

VRC.BulkStateView = (function () {

	var _$mainBulkTanks;
	var MARGIN_PRESENTAGE = 0;
	var BULK_TANK_SIZE = 130;
	var _size;
	var _deckWidth;

	var createContext = function (tanks) {

		var transformedTanks = transformBulkStateData(tanks);

		var numberOfColumns = findNumberOfColumns(transformedTanks);
		_size = VRC.BulkViewUtil.calculateSize(MARGIN_PRESENTAGE, numberOfColumns);
		_deckWidth = (numberOfColumns * BULK_TANK_SIZE) + 'px';
		var portColors = findPortColorsInBulkState(tanks);
		var pumpSystems = findPumpSystemsInBulkState(tanks);

		var bulkStateData = {
			main: {
				bulkTanks: transformedTanks,
				//summary: data.summary,
				size: _size,
				margin: MARGIN_PRESENTAGE,
				portColors: portColors,
				units: VRC.MasterDataService.getBulkValueUnitsAsArray(),
				deckWidth: _deckWidth,
				pumpSystems: pumpSystems
			}
		};

		return bulkStateData;
	};

	var transformBulkStateData = function (tanks) {

		return _.chain(tanks).each(function (tank) {
			// Find the latest content from the list based on the date field
			if (tank.content && tank.content !== undefined) {

				var index = 0;
				var currentLatestDate;
				for (var i = 0; i < tank.content.length; i++) {

					var content = tank.content[i];
					var date = moment(content.date, g_timeStampFormat);
					if (currentLatestDate && currentLatestDate.isBefore(date)) {
						currentLatestDate = date;
						index = i;
					}
				}

				tank.content = tank.content[index];
			}
		}).sortBy(function (tank) {
			return tank['positionX'];
		}).groupBy(function (tank) {
			return tank['positionY'];
		}).map(function (tank) {
			return tank;
		}).each(function (group) {
			for (var i = 0; i < group.length; i++) {
				var tank = group[i];
				if (tank['positionX'] && tank['positionX'] > i + 1) {
					group.splice(i, 0, {tankShape: 'hidden_tank'});
				}
			}
		}).value();
	};

	var findNumberOfColumns = function (tanks) {
		var rowMax = _.chain(tanks).max(function (row) {
			var max = _.max(row, function (tank) {
				return tank['positionX'];
			});

			return max['positionX'];
		}).last().value();

		return rowMax['positionX'] || 0;
	};

	var findPortColorsInBulkState = function (tanks) {

		var portColors = _.chain(tanks)
			.groupBy(function (tank) {

				if (tank.content) {
					if (tank.content.displayPort && tank.content.action !== 'rob' && (tank.content.action === 'tank_clean' || tank.content.qtyRob > 0)) {
						return tank.content.displayPort;
					}
				}

			}).filter(function (group, key) {
				return key !== "undefined";
			})
			.map(function (group, key) {

				var item = _.first(group).content;

				if (item) {
					return {
						portName: item.displayPort,
						portColorCode: item.tankColor
					};
				}
			}).sortBy(function (tank) {

				if (tank) {
					return tank.portColorCode;
				}
			}).value();
		return portColors;

	};

	var findPumpSystemsInBulkState = function (tanks) {
		var pumpSystems;
		pumpSystems = _.chain(tanks)

			.filter(function (tank) {
				return (tank.bulkTankPumpSystemName || tank.pumpSystemColorCode)
			})
			.uniq(function (tank) {
				return tank.bulkTankPumpSystemName
			})
			.map(function(tank) {
				return {
					bulkTankPumpSystemName: tank.bulkTankPumpSystemName,
					pumpSystemColorCode: tank.pumpSystemColorCode
				}
			}).value();

		return pumpSystems
	};

	var filterByPumpSystem = function (pumpSystemElement) {
		var pumpSystemName = $(pumpSystemElement).data('pumpSystemName');
		var $filteredBulkTankContainers = $('.bulk_tank_container[data-pump-system-name="'+pumpSystemName+'"]');
		if ($filteredBulkTankContainers.length) {
			$('.bulk_tank_container').not($filteredBulkTankContainers).css('visibility', 'hidden');
			$filteredBulkTankContainers.css('visibility', 'visible');
		} else {
			$('.bulk_tank_container').css('visibility', 'visible');
		}
	};

	var getBulkTankElement = function (bulkTankId) {
		return $("#bulk-state-container").find('.bulk_tank[data-bulk-tank-id=' + bulkTankId + ']');
	};
	var getBulkTankContainer = function (bulkTankId) {
		return $("#bulk-state-container").find('.bulk_tank[data-bulk-tank-id=' + bulkTankId + ']').closest('.bulk_tank_container');
	};
	var getPortList = function () {
		return $("#bulk-state-container").find('.port-color-codes');
	};

	var renderTank = function (tank) {
		var bulkTankId = tank.getBulkTankId();
		var tankJson = tank.toJson();
		var content = tank.getLatestContent();

		tankJson.main = {
			size: _size,
			margin: MARGIN_PRESENTAGE
		};

		if (content && content !== -Infinity) {
			tankJson.content = content.toJson();
		}

		var html = Handlebars.partials['bulk_tank'](tankJson);
		var $tank = getBulkTankContainer(bulkTankId);
		$tank.replaceWith(html);

		selectMainBulkTanks();

		attachModal('#bulk_tank_' + bulkTankId);
		reRenderPortColors();

	};

	var reRenderPortColors = function () {
		var bulkTanks = VRC.BulkTankManager.toJson();
		bulkTanks = _.flatten(transformBulkStateData(bulkTanks));

		var portColors = findPortColorsInBulkState(bulkTanks);

		var html = Handlebars.partials['port_colors'](portColors);
		var $portList = getPortList();
		$portList.replaceWith(html);
	};

	var selectMainBulkTanks = function () {
		_$mainBulkTanks = $('.bulk_deck.main .bulk_tank');
	};

	var render = function () {
		var bulkTanks = VRC.BulkTankManager.toJson();
		var context = createContext(bulkTanks);
		var $container = $('#bulk-state-container');

		var content = WELL.Handlebars.VRC['bulk_state'](context);
		$container.html(content);

		selectMainBulkTanks();

		attachDropEvents();
		attachDragEvent();
		attachModal('.bulk_deck.main .bulk_tank');
		attachSubMenu();
	};

	var attachSubMenu = function () {
		$("#bulk_page-submenu__tankclean-btn").unbind('click').click(function () {
			VRC.TankCleanModal.render();
		});
		$("#bulk_page-submenu__robvalidation-btn").unbind('click').click(function(e) {
            e.preventDefault();

            g_remote_object.FetchHTMLFromServer( g_bulk_planning, ParseWELSForm, 'info', 'rob_validation');
		})
	};

	var attachModal = function (query) {
		interact(query).on('tap', function (e) {
			var $bulkTank = $(e.target).closest('.bulk_tank');
			var bulkTankId = $bulkTank.attr('data-bulk-tank-id');
			VRC.BulkModalView.render(bulkTankId);
		});
	};

	var showPopover = function (bulkCargoRequest, $bulkTank, bulkTank) {
		var rule;
		var lastAction = bulkTank.getLastAction();
		if (lastAction) {
			if (VRC.BulkCompatibility.hasComponent()) {
				rule = VRC.BulkCompatibility.canMixBulk(bulkCargoRequest.getItemGroupId(), lastAction.getItemGroupId());
			}

		}

		var ctx = {
			qtyRob: bulkTank.getQtyRob() + bulkCargoRequest.getValueQty(),
			date: moment().format(g_timeStampFormat),
			request: bulkCargoRequest.toJson(),
			rule: rule,
			units: VRC.MasterDataService.getBulkValueUnitsAsArray(),
			action: 'load'
		};

		var popOverHtml = WELL.Handlebars.VRC.loadingQuantitySelection(ctx);
		$bulkTank.attr('data-content', popOverHtml);
		$bulkTank.popover({ html: true, placement: 'left auto', sanitize: false });
		$bulkTank.popover('show');

	};

	var showPopup = function (dropzoneElement, bulkCargoRequest, bulkTank) {
		var $bulkTank = $(dropzoneElement);

		showPopover(bulkCargoRequest, $bulkTank, bulkTank);

		var $popover = $bulkTank.next();
		$popover.find('.popover-title').text(bulkCargoRequest.getItemDescription() + ' to ' + bulkTank.getName());
		var $valueType = $popover.find('#popover__valueUnit');
		var $date = $popover.find('#popover__date');
		$valueType.selectpicker();
		$date.datetimepicker({format: g_timeStampFormat});
		var $valueQty = $popover.find('#popover__valueQty');

		var $qtyRob = $popover.find('#popover__qtyRob');
		var $remarkField = $popover.find('#popover__remarks');

		$valueQty.focus();

		$valueQty.keyup(function (e) {

			try {
				var qty = parseInt($(e.target).val());
				$qtyRob.val(bulkTank.getQtyRob() + qty);
			}
			catch (e) {
				$qtyRob.val(bulkTank.getQtyRob());
			}

		});

		$('.bulk-insertion-cancel').click(function (e) {
			e.preventDefault();
			cancelBulkAction($bulkTank)
		});

		$('.bulk-insertion-confirm').click(function (e) {
			e.preventDefault();
			insertBulkAction($bulkTank, $valueQty, $date, $qtyRob, $remarkField, $valueType, bulkTank, bulkCargoRequest)

		});
	};

	var cancelBulkAction = function ($bulkTank) {
		$bulkTank.popover('destroy');
	};

	var insertBulkAction = function ($bulkTank, $valueQty, $date, $qtyRob, $remarkField, $valueType, bulkTank, bulkCargoRequest) {
		//Getting values from popover

		var qty = VRC.Utils.Number.parseFloat($valueQty.val());
		qty = qty || 0;

		var qtyRob = VRC.Utils.Number.parseFloat($qtyRob.val());
		qtyRob = qtyRob || 0;

		var date = $date.val();

		var inputRemarks = $remarkField.val();

		var type = $valueType.val();

		//Creating new VoyageBulk, adding to tank
		var voyageBulk = VRC.VoyageBulk({bulkTankId: bulkTank.getBulkTankId()});
		voyageBulk.parseFromBulkRequest(bulkCargoRequest, bulkTank, qty, qtyRob, date, inputRemarks, type);
		bulkTank.addContent(voyageBulk);

		bulkCargoRequest.subtractValueQty(qty);

		//UpdateUi
		$bulkTank.popover('destroy');
		renderTank(bulkTank);

		VRC.BulkLoadingAreaView.reRenderBulkRequest(bulkCargoRequest);
	};

	var attachDropEvents = function () {
		var mainBulkTanksInteraction = interact('.bulk_deck.main .bulk_tank:not(.hidden_tank)');

		mainBulkTanksInteraction.dropzone({
			accept: '.request',
			ondropactivate: function () {
				// add active dropzone feedback
				_$mainBulkTanks.addClass('can-drop');
			},
			ondragenter: function (event) {
				var dropzoneElement = event.target;

				// feedback the possibility of a drop
				dropzoneElement.classList.add('drop-target');
			},
			ondragleave: function (event) {
				var dropzoneElement = event.target;
				// remove the drop feedback style
				dropzoneElement.classList.remove('drop-target');
			},
			ondrop: function (event) {
				var draggableElement = event.relatedTarget;
				var dropzoneElement = event.target;

				dropzoneElement.classList.remove('drop-target');

				var cargoId = draggableElement.getAttribute('data-container-id');
				var cargoRequest = VRC.BulkCargoRequestManager.getBulkCargoRequestById(cargoId);

				var tankId = dropzoneElement.getAttribute('data-bulk-tank-id');
				var tank = VRC.BulkTankManager.getBulkTankById(tankId);

				showPopup(dropzoneElement, cargoRequest, tank);
			},
			ondropdeactivate: function () {
				_$mainBulkTanks.removeClass('can-drop');
			}
		});
	};

	var attachDragEvent = function () {
		var mainBulkTanksInteraction = interact('.bulk_deck.main .bulk_tank');

		mainBulkTanksInteraction.draggable({
			autoScroll: true,
			onstart: function (event) {
				if (!$(event.target).hasClass('filled')) {
					return;
				}
				if (this.enabled === false) {
					return;
				}

				var target = event.target;

				target.style.zIndex = '1000';
				$(target).addClass('drag-element');

			},
			onmove: function (event) {
				if (this.enabled === false) {
					return;
				}
				if (!$(event.target).hasClass('filled')) {
					return;
				}

				var target = event.target,
				// keep the dragged position in the data-x/data-y attributes
					x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx,
					y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;

				// translate the element
				target.style.webkitTransform = target.style.transform = 'translate(' + x + 'px, ' + y + 'px)';

				// update the posiion attributes
				target.setAttribute('data-x', x);
				target.setAttribute('data-y', y);
			},
			// call this function on every dragend event
			onend: function (event) {
				if (this.enabled === false) {
					return;
				}
				if (!$(event.target).hasClass('filled')) {
					return;
				}

				var target = event.target;

				$(target).removeClass('drag-element');
				target.style.zIndex = 'auto';
				target.style.transform = 'translate(0, 0)';
				target.setAttribute('data-x', '0');
				target.setAttribute('data-y', '0');
				setTimeout(function () {
					attachModal('.bulk_deck.main .bulk_tank');
				}, 0)

			}
		});
	};

	var init = function () {
		VRC.BulkModalView.init();
		render();

	};

	return {
		transformBulkStateData: transformBulkStateData,
		findNumberOfColumns: findNumberOfColumns,
		findPortColorsInBulkState: findPortColorsInBulkState,
		createContext: createContext,
		render: render,
		renderTank: renderTank,
		init: init,
		getBulkTankElement: getBulkTankElement,
		filterByPumpSystem: filterByPumpSystem
	}
})();
